import {
    getInitializedScenarioIds,
    getUpNextCalendarEventWithOnlineEventsHappeningNow,
} from '../selectors/upNextStoreSelectors';
import { loadFullEvent } from 'owa-calendar-events-loader';
import { observableNowChanged } from 'owa-observable-datetime';
import { isValidOnlineMeeting } from 'owa-online-meeting/lib/bootIndex';
import { orchestrator } from 'satcheljs';

orchestrator(observableNowChanged, () => {
    getInitializedScenarioIds().forEach(key => {
        const {
            upNextEvent,
            onlineEventsHappeningNow,
        } = getUpNextCalendarEventWithOnlineEventsHappeningNow(key);

        if (upNextEvent && !isValidOnlineMeeting(upNextEvent, true)) {
            loadFullEvent(key, upNextEvent.ItemId);
        }

        onlineEventsHappeningNow.forEach(event => {
            // skip further processing since already handled above
            if (upNextEvent && event.ItemId.Id === upNextEvent.ItemId.Id) {
                return;
            }
            if (!isValidOnlineMeeting(event, true)) {
                loadFullEvent(key, event.ItemId);
            }
        });
    });
});
